<div class="long-card-wrapper" [class.embed-mode]="embedMode">
    <div class="long-card">
        <div class="logo-container" *ngIf="!embedMode">
            <a href="/login">
                <app-logo-dark></app-logo-dark>
                <app-logo></app-logo>
            </a>
        </div>
        <ng-content></ng-content>
    </div>
</div>
